<router-outlet>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-scale-multiple"></ngx-spinner>
    <!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
</router-outlet>
